import classes from './UserProfile.module.css';

const UserProfile = () => {
  return (
    <main className={classes.profile}>
      <h2>As you had logged in now you can access counter</h2>
    </main>
  );
};

export default UserProfile;
